import { memo } from 'react';
import { SEVERITY_COLOR, KIND_ICON } from './replayEventMeta';

/**
 * Horizontal lane aligned to the scrubber width. Each event is a severity-
 * colored badge carrying its kind icon, placed at `event.progress`. Uses
 * inset-inline so it mirrors correctly in RTL. Badges in a tight cluster
 * overlap; the active event (blue ring) and later events stack on top.
 *
 * memo'd: its host (ReplayTripPlayer) re-renders every playback frame to move
 * the scrubber, but the badges only change when `events`/`activeId` change.
 */
function ReplayEventTrack({ events, activeId, onSelect }) {
  return (
    <div className="relative h-8 w-full">
      <div className="absolute top-1/2 inset-x-0 h-px bg-slate-300/70 dark:bg-slate-600/70" />
      {events.map((e) => {
        const Icon = KIND_ICON[e.kind] || KIND_ICON.stop;
        const active = e.id === activeId;
        return (
          <button
            key={e.id}
            type="button"
            onClick={() => onSelect(e)}
            title={e.label}
            className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 rtl:translate-x-1/2 w-[18px] h-[18px] rounded-full border-2 border-white shadow flex items-center justify-center transition-transform hover:scale-125"
            style={{
              insetInlineStart: `${e.progress * 100}%`,
              background: SEVERITY_COLOR[e.severity] || SEVERITY_COLOR.info,
              outline: active ? '2px solid #3b82f6' : 'none',
              zIndex: active ? 3 : 1,
            }}
          >
            <Icon size={11} color="#fff" strokeWidth={2.5} />
          </button>
        );
      })}
    </div>
  );
}

export default memo(ReplayEventTrack);
